import { Outlet, createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_individual/individual/_profile')({
  component: ProfileLayout
});
function ProfileLayout() {
  return <Outlet />;
}